export const isOwner = (state, getters, rootState) => {
  return (
    rootState.session.user &&
    state.current._user &&
    rootState.session.user._id === state.current._user._id
  );
};

export const canEdit = (state, getters, rootState, rootGetters) => {
  return isOwner(state, getters, rootState) || rootGetters.isAdmin;
};
